var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.102 11.317l2.115-1.162a.563.563 0 01.545 0l2.115 1.162a.563.563 0 00.371.061.609.609 0 00.477-.705l-.404-2.462a.628.628 0 01.168-.54l1.712-1.744a.621.621 0 00.17-.35.607.607 0 00-.494-.692l-2.365-.359a.587.587 0 01-.44-.334l-1.058-2.24a.573.573 0 00-1.048 0l-1.058 2.24a.587.587 0 01-.44.334l-2.366.36a.576.576 0 00-.334.177.63.63 0 00.01.864L3.49 7.671c.137.14.2.342.168.54l-.404 2.462a.635.635 0 00.058.388c.15.298.504.413.79.256zM7.35 9.084l.963.53-.198-1.204a1.85 1.85 0 01.502-1.595l.886-.902-1.175-.179a1.809 1.809 0 01-1.361-1.02l-.477-1.01v5.159c.296 0 .592.074.86.221z",
    fill: "#FF7D6B"
  })));
}
export default SvgIcnStarHalf;